import { createContext, useState, useReducer } from 'react';
import PlateExperimentControl from './PlateExperimentControl';
import PlateExperimentEditor from './PlateExperimentEditor';
import NewPlateExperiment from './NewPlateExperiment';
import { produce } from 'immer';
import PlateSelectionProvider from './PlateSelectionProvider';
import FilesystemListContainer from './FilesystemListContainer';


import { FilesystemStore } from './Contexts';
import { useSelector } from 'react-redux';
import G from './Getters';

export const GlobalStateContext = createContext();





function Grid(rows,cols){
  return Array(rows).fill(null).map(() => Array(cols).fill([]));
}


const colorPriorities = ["red","green","blue","orange","purple","magenta","aqua","dodgerblue","mediumseagreen","gold"]

const defaultState = {
  experiments:{
    e0:{

      variableMap:[],
      //{substance:"Jonah",color:"purple",displayText:"Jonah"},{substance:"Jonah",color:"purple",displayText:"Jonah"}],

      grids:{ 
        init:Grid(8,12),
        g1:Grid(8,12),
        g2:Grid(8,12),
      },

      colorMap:{},
      nameMap:{},
    },

    e1:{
      variableMap:[],

      grids:{ 
        init:Grid(8,12),
        g1:Grid(8,12),
        g2:Grid(8,12),
      },

      colorMap:{},
      nameMap:{},
    }
  }
}


function reducer(state,action){

  let { type } = action;
  switch(type){

    case "createExperiment":{
      let { creationArgs, experimentId } = action;
      return produce(state,draft => {

        let { template, blank } = creationArgs;

        let grid;
        let variableMap = [];

        if( template ){
          let exp = state.experiments[template.experimentId];
          grid = exp.grids[template.gridId];
          variableMap = exp.variableMap.map(vv => {
            return {
              color:vv.color,
              substance:"undefined",
              displayText:"undefined"
            }
          })

        }else{
          if( blank === "96-well" ){
            grid = Grid(8,12)
          }else{
            grid = Grid( 16, 24 );
          }

        }

        draft.experiments[experimentId] = {

          grids:{
            init:grid,
          },
          variableMap

        }

      })
    }

    case "setSubstance":{
      let { experimentId, variableId, substance } = action;
      return produce(state,draft => {

        let experiment = draft.experiments[ experimentId ];
        let varMap = experiment.variableMap;
        varMap[variableId].substance = substance;
        varMap[variableId].displayText = substance;


      });
    }

    case "clearWellsSubstances":{

      let { wells, experimentId, substanceId } = action;
      return produce(state,draft => {

        let exp = draft.experiments[experimentId];

        wells.forEach(({gridId, row, col}) => {
          let grid = exp.grids[gridId]
          delete grid[row][col][substanceId]
        })


      });

    }
    case "clearWells":{
      let { wells, experimentId } = action;
      return produce(state,draft => {

        let exp = draft.experiments[experimentId];

        wells.forEach(({gridId, row, col}) => {
          let grid = exp.grids[gridId]
          grid[row][col] = [];
        })


      });
    }
    case "setVariableDisplayText":{
      let { experimentId, variableId, displayText } = action;
      return produce(state,draft => {
        draft.experiments[experimentId].variableMap[variableId].displayText = displayText;
      });
    }
    case "setExperimentData":{
      let { experimentId, data } = action;
      return produce(state,draft => {
        draft.experiments[experimentId] = data;
      })

    }
    case "setWellsValue":{
      let { wells, experimentId, value, substanceId } = action;
      return produce(state,draft => {

        let exp = draft.experiments[experimentId];

        wells.forEach(({gridId, row, col}) => {
          let grid = exp.grids[gridId]
          grid[row][col][substanceId].value = value;
        })


      })


    }
    case "setWellData":{
      let { gridId, coordMap, experimentId } = action;

      debugger;

      let final = produce(state,draft => {
        let { grids, variableMap } = draft.experiments[experimentId]
        let grid = grids[gridId];
        for(let row in coordMap){
          for(let col in coordMap[row]){

            let newValue = coordMap[row][col];
            let curGridValue = grid[row][col];

            let substanceId = variableMap.findIndex(vv => vv.substance === newValue.substance);
            if( substanceId === -1 ){
              substanceId = variableMap.length;
              variableMap[substanceId] = { 
                substance:newValue.substance, 
                displayText:newValue.substance, 
                color:colorPriorities[substanceId]
              }
            }

            let insertionIndex = curGridValue.findIndex((item) => item?.substance === substanceId);

            if( insertionIndex === -1 ){
              insertionIndex = curGridValue.length;
            }else{
              debugger;
            }


            let substance = newValue.substance;
            let substanceVariableIndex = variableMap.findIndex(vv => vv.substance === substance)
            //first, get the var

            let abstractedValue = {...newValue,substance:substanceId};

            curGridValue[substanceId] = abstractedValue;




          }
        }
      })
      debugger;
      return final;

    }
    default:
      throw Error("No event registered '"+type+"'");
  }
  return state;
}


export default function PlateScene(){


  const [ selectedExperimentId, setSelectedExperimentId ] = useState();

  const topLevelDirectoryId = useSelector(state => G.getTopLevelDirectoryId(state,{itemType:"plateExperiments"}));



  //three main view

  // - plate editor
  // - blank
  // - new plate selection

  const [ state, set ] = useReducer( reducer, defaultState );



  let mainView;
  if( selectedExperimentId === "new" ){
    mainView = <NewPlateExperiment setSelectedExperimentId={setSelectedExperimentId} state={state} set={set}/>
  }else if( selectedExperimentId ){
    mainView = <PlateExperimentEditor key={setSelectedExperimentId} {...{selectedExperimentId,state,set}}/>
  }

  return (

    <GlobalStateContext.Provider value={{state,set,experimentId:selectedExperimentId}}>
    <PlateSelectionProvider>
    <div class="sg-row full-height full-width">

      <div style={{width:300}}>
      <FilesystemStore.Provider value={{
        isFilesystemItemSelected:(_id) => {

          return (
            selectedExperimentId === _id
          );

        },
        onFilesystemItemEvent:({_id,event}) => {
          setSelectedExperimentId(_id);
        }
      }}>
        {false && <FilesystemListContainer {...{
        filesystemContaine:"plates",
        topLevelDirectoryId
      }}/>}
      </FilesystemStore.Provider>
      </div>

      <PlateExperimentControl 
      state={state} 
      setSelectedExperimentId={setSelectedExperimentId} 
      selectedExperimentId={selectedExperimentId}/>



      {mainView}
    </div>
    </PlateSelectionProvider>
    </GlobalStateContext.Provider>



  )
}
